<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<CustomerCompanySearchDialog text :query="q" :industries="industries" @search-customer-companies="searchCustomerCompanies" />
				<v-btn v-if="authorized" class="ml-2" color="white" @click="$router.push({ name: 'customer_company_new' })" text
					><v-icon class="mr-1">mdi-plus</v-icon>顧客企業登録</v-btn
				>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end">
					<CustomerCompanySearchDialog :query="q" :industries="industries" @search-customer-companies="searchCustomerCompanies" />
					<v-btn v-if="authorized" color="secondary" class="ml-2 mb-2" @click="$router.push({ name: 'customer_company_new' })"
						><v-icon class="mr-1">mdi-plus</v-icon>顧客企業登録</v-btn
					>
				</v-row>
			</template>

			<div class="table-container px-2 mt-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="customer_companies"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="見つかりませんでした。"
				>
					<template v-slot:item="{ item }">
						<tr @click="showDialog(item)" class="clickable">
							<td>{{ item.name }}</td>
							<td>{{ item.customer_code }}</td>
							<td>{{ item.industry ? item.industry.name : "" }}</td>
							<td>
								<template v-for="(tag, i) in item.customer_company_tags">
									<span :key="i">
										{{ tag.name }}
									</span>
								</template>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</CommonFlame>
		<CustomerCompanyShowDialog
			v-if="open"
			:customer_company.sync="selectedCustomerCompany"
			@update-column="updateColumn($event)"
			@close="open = false"
			:authorized="authorized"
			:industries="industries"
			:cutoffDates="cutoffDates"
			@reload-customer-companies="fetchCustomerCompanies(pagination.current)"
		/>
	</v-sheet>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import PaginationModule from "../shared/PaginationModule.vue"
import CustomerCompanyShowDialog from "./components/CustomerCompanyShowDialog.vue"
import CustomerCompanySearchDialog from "./components/CustomerCompanySearchDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		PaginationModule,
		CustomerCompanyShowDialog,
		CustomerCompanySearchDialog,
	},
	// 使わなければ削除すること
	filters: {
		dateFormatter(date) {
			if (!date) return
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter(time) {
			if (!time) return
			return moment(time).format("HH:mm")
		},
	},
	data() {
		return {
			mainTitle: "顧客企業情報",
			pageTitle: "顧客企業一覧",
			selectedCustomerCompany: {
				id: null,
				name: null,
				full_name: null,
				customer_code: null,
				zipcode: null,
				address: null,
				building: null,
				phone: null,
				fax: null,
				email: null,
				customer_company_share_info: {
					name: null,
					capital: null,
					establishment_date: null,
					employees_number: null,
					representative: null,
					representative_kana: null,
					website: null,
				},
				industry: {
					name: null,
				},
				customer_company_people: [],
				customer_company_tags: [],
			},
			open: false,
			authorized: false,
			customer_companies: [],
			industries: [],
			cutoffDates:[],
			headers: [
				{ text: "顧客企業名", value: "name", width: "200px" },
				{ text: "得意先コード", value: "customer_code", width: "200px" },
				{ text: "業種", value: "industry_name", width: "150px" },
				{ text: "タグ名", value: "customer_company_tags_name", width: "300px" },
			],
			q: {
				name_cont: null,
				customer_code_eq: null,
				industry_id_eq: null,
				company_tags_name_cont: null,
			},
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.setQuery()
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.fetchCustomerCompanies(page)
	},
	methods: {
		fetchCustomerCompanies(page) {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/customer_companies`
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			axios
				.get(url, { headers, params, paramsSerializer })
				.then((res) => {
					this.customer_companies = res.data.customer_companies
					this.pagination = res.data.pagination
					this.authorized = res.data.authorized
					this.industries = res.data.industries
					this.cutoffDates = res.data.cutoff_dates
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		searchCustomerCompanies() {
			this.fetchCustomerCompanies(1)
			this.$router.push({
				name: "customer_company_index",
				query: { ...this.q, page: 1 },
			})
		},
		getPage(i) {
			this.fetchCustomerCompanies(i)
			this.$router.push({
				name: "customer_company_index",
				query: { ...this.q, page: i },
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		showDialog(e) {
			if (this.selectedCustomerCompany?.id != e.id) {
				const headers = authenticate.setHeader()
				const url = `/erp/v1/customer_companies/${e.id}`
				axios
					.get(url, { headers })
					.then((res) => {
						this.open = true
						this.selectedCustomerCompany = res.data.customer_company
					})
					.catch((err) => {
						errorHandling.errorResponse(err)
					})
			} else {
				this.open = true
			}
		},
		setQuery() {
			const query = this.$route.query
			if (query) {
				Object.keys(this.$route.query).forEach((query_key) => {
					if (query[query_key] && query_key != "page") {
						this.q[query_key] = this.formatQuery(query[query_key])
					}
				})
			}
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		updateColumn(obj) {
			const customerCompany = this.customer_companies.find((c) => c.id == obj.customer_company.id)
			if (!customerCompany) return
			const i = this.customer_companies.indexOf(customerCompany)
			this.$set(this.customer_companies[i], obj.columnName, obj.customer_company[obj.columnName])
		},
	},
}
</script>